module.exports = __webpack_public_path__ + "img/brand-1.55ea92c6.png";